// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/pitot-static.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/pitot-static/pitot-static.js';

mount([g0]);
